//export const BASE_URL='http://localhost:5002/';
export const ENV_VAR={
    Prod:'production',
    Dev:'development'
}
export const ENV=ENV_VAR.Prod; //production or development
export const BASE_URL= ENV===ENV_VAR.Prod?'https://tmtsapi.sciata.com/':'https://devtmtsapi.sciata.com/';
export const CONTEXT_PATH='api';
export const CLIENT_AUTHENTICATION={clientId:'my-trusted-client',secretId:'secret'}
export const DB_DATE_FORMAT='MM-DD-YYYY';
export const DB_YEAR_MONTH='YYYYMM';
export const DISPLAY_DATE_FORMAT="MM/DD/YYYY";
export const DISPLAY_YEAR_MONTH='MM/YYYY'
export const UPLOAD_FILE_SIZE=15; //in MB 
export const EMPLOYEE_TYPE={
    Contractor:'contractor',
    Fulltime:'fulltime'
}
export const USER_ROLE={
    User:'user',
    Admin:'admin',
    Hr: 'hr',
    Manager: 'manager'
}